import { forwardRef, useState, useImperativeHandle } from "react";
import { Dialog, Divider } from "@mui/material";
import WhatsNewDetail from "./WhatsNewDetail";
import get_cid from "../lib/get_cid";
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect } from "react";
import axios from "axios";
import { configState } from "../lib/State";

const WhatsNew = forwardRef(({ login }, ref) => {
  const [data, setData] = useState();
  const [open, setOpen] = useState(false);
  const cid = get_cid();

  useImperativeHandle(ref, () => ({
    open() {
      setOpen(true);
    },
  }));

  const closeClick = () => {
    setOpen(false);
  };

  useEffect(() => {
    const getData = async () => {
      const result = await axios.post(
        configState.api + "/gympass/whatsnew_all",
        {
          cid,
        }
      );
      if (!result?.data?.success) return;
      if (!result.data.rows.length) return;
      setData(result.data.rows);
    };
    getData();
  }, []);

  return (
    <>
      {/* 팝업 */}
      <Dialog fullScreen open={open} onClose={closeClick}>
        <section className="p-[30px_0_10px_10px]">
          <img src="/img/back_button_black.png" onClick={closeClick} />
          <p className="m-[25px_0_0_10px] text-[22px] font-bold">What's New</p>
        </section>
        <Divider />
        {data &&
          data.map((item) => (
            <WhatsNewDetail data={item} key={item.id}>
              <article className="flex justify-center items-center m-[30px_30px_0_30px] gap-2">
                <img src={item.menu_img} className="w-[40%] rounded-[3px]" />
                <div className="flex flex-col w-[70%]">
                  <p>{item.sub_text}</p>
                  <p className="text-[14px] text-[#c9c9c9]">{item.sdate}</p>
                </div>
              </article>
            </WhatsNewDetail>
          ))}
      </Dialog>

      {/* 왓츠 뉴 */}
      {data && (
        <section className="overflow-hidden w-full">
          {/* 타이틀 */}
          <article className="mt-[20px] px-[5%]">
            <p
              className="text-[24px] text-[400] mb-[10px]"
              sx={{
                fontSize: "24px",
                fontWeight: "400",
                marginBottom: "10px",
              }}
            >
              What's New
            </p>
          </article>
          {/* 슬라이드 */}
          <Swiper
            slidesOffsetBefore={24}
            slidesOffsetAfter={24}
            grabCursor={true}
            slidesPerView={1.3}
            className="w-full z-[1] mb-[30px] mySwiper"
          >
            {data.map((item) => (
              <SwiperSlide onClick={() => setOpen(true)} key={item.id}>
                <img
                  className="h-[150px] rounded-[5px] mb-[5px] z-[1]"
                  src={item.menu_img}
                  alt=""
                />
                <div className="w-[270px] z-[1]">
                  <p className="font-bold text-[18px] z-[1]">{item.title}</p>
                  <p className="text-[14px] z-[1]">{item.sub_text}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      )}
    </>
  );
});

export default WhatsNew;
